import { render, staticRenderFns } from "./title-comp.vue?vue&type=template&id=28af2016"
import script from "./title-comp.vue?vue&type=script&lang=js"
export * from "./title-comp.vue?vue&type=script&lang=js"
import style0 from "./title-comp.vue?vue&type=style&index=0&id=28af2016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports